import React, { useState } from "react";
import { Icon } from "../../../../shared/Icon/Icon";
import { InsightsModal } from "./InsightsModal";
import { Role } from "../../../../../api/grpc/account/account";

export interface CustomerSettingsVariables {
  startTime?: string;
  endTime?: string;
  errorReportingEmail?: string;
  meetingSpaceCostPerHr?: number;
  currency?: string;
  workingWeekDays?: number[];
  collectInsights?: boolean;
  ssoEnable?: boolean;
  disableDeskSimultaneous?: boolean;
  showEventOrganizer?: boolean;
  deskBookingDisabledForRoles?: Role[];
  deskBookingEnabled?: boolean;
  roomBookingDisabledForRoles?: Role[];
  roomBookingEnabled?: boolean;
  systemNotificationRecipientUserIds?: string[];
}

interface Props {
  loading: boolean;
  handleInsightsCollect: ({
    collectInsights,
  }: CustomerSettingsVariables) => void;
  collectData?: boolean;
  showEventOrganizer?: boolean;
  error?: Error;
}

export const Insights = ({
  loading,
  handleInsightsCollect,
  collectData,
  showEventOrganizer,
  error,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex-a-center cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <Icon icon="insights_icon" />
        <h3>Insights</h3>
      </div>

      {isOpen && (
        <InsightsModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          handleInsightsCollect={handleInsightsCollect}
          collectData={collectData}
          showEventOrganizer={showEventOrganizer}
          loading={loading}
          error={error}
        />
      )}
    </>
  );
};
